<template>
    <bind-bank-card @completed="completed">
        <template v-slot:header>
            <breadcrumbs class="view__breadcrumbs" :links="{ to: { name: 'balance' }, text: 'Назад' }"></breadcrumbs>

            <h2 class="title form__title view__title">Смена банковской карты</h2>
        </template>
    </bind-bank-card>
</template>

<script>
  import BindBankCard from "../components/BankCardBind/BankCardBind";

  export default {
    components: { BindBankCard },
    methods: {
      completed() {
        this.$router.push({ name: "balance" });
      }
    }
  }
</script>